export default __webpack_public_path__ + "static/media/twitter.e5f33747.svg";